import React, { useEffect } from 'react';
import localize from '../../../../core/utils/translation-files';
import { Tag } from 'antd';
import { useSelector } from 'react-redux';
import { LookupNames } from '../../../../core/constants/lookup';
import IntegrationFormFields from './integrationFormFields';
import cloneDeep from 'lodash/cloneDeep';
import './styles.scss';
import { DEFAULT_MANUAL_INTEGRATION_SYSTEM } from '../../../../core/constants/integrationFormFieldsConstants';
const IntegrationCredentialsForm = ({ values, setFieldValue, activeIntegration, setActiveIntegration, }) => {
    const [activeIntegrationSystemTypes, setActiveIntegrationSystemTypes] = React.useState([]);
    const [activeFormFields, setActiveFormFields] = React.useState([]);
    const lookUpsOfIntegrationSystem = useSelector((state) => { var _a; return (_a = state.lookups[LookupNames.LKIntegrationSystem]) !== null && _a !== void 0 ? _a : []; });
    const lookUpsOfIntegrationSystemType = useSelector((state) => { var _a; return (_a = state.lookups[LookupNames.LKIntegrationSystemType]) !== null && _a !== void 0 ? _a : []; });
    const lookUpsOfIntegrationSystemFields = useSelector((state) => { var _a; return (_a = state.lookups[LookupNames.LKIntegrationSystemFields]) !== null && _a !== void 0 ? _a : []; });
    const lookUpsOfISFieldValidations = useSelector((state) => { var _a; return (_a = state.lookups[LookupNames.LKIntegrationSystemFieldValidations]) !== null && _a !== void 0 ? _a : []; });
    useEffect(() => {
        var _a;
        const activeOperationSystem = activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationSystem;
        if (!activeOperationSystem) {
            setActiveFormFields([]);
            setActiveIntegrationSystemTypes([]);
            return;
        }
        const activeSystem = lookUpsOfIntegrationSystem.find(item => item.code == activeOperationSystem);
        if (!activeSystem)
            return;
        setActiveIntegration(prev => (Object.assign(Object.assign({}, prev), { systemName: activeSystem.text })));
        let activeSystemTypes = (_a = lookUpsOfIntegrationSystemType.filter(item => item.lookupParentCode === activeSystem.code)) !== null && _a !== void 0 ? _a : [];
        if (!activeSystemTypes.some(item => item.code === DEFAULT_MANUAL_INTEGRATION_SYSTEM)) {
            activeSystemTypes.push({
                "code": DEFAULT_MANUAL_INTEGRATION_SYSTEM,
                "text": "Manual",
            });
        }
        setActiveIntegrationSystemTypes(activeSystemTypes);
        // Auto-select type if not already set
        if (!(activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationType) && activeSystemTypes.length > 0) {
            setActiveIntegration(prev => (Object.assign(Object.assign({}, prev), { integrationType: activeSystemTypes[0].code })));
        }
    }, [activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationSystem]);
    useEffect(() => {
        const activeSystemType = activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationType;
        if (!activeSystemType) {
            setActiveFormFields([]);
            return;
        }
        const activeFields = lookUpsOfIntegrationSystemFields.filter(item => item.lookupParentCode === activeSystemType);
        const activeFieldsWithValidations = activeFields.map(field => {
            const clonedField = cloneDeep(field);
            clonedField.fieldValidations = lookUpsOfISFieldValidations.filter(item => item.lookupParentCode === field.code);
            return clonedField;
        });
        setActiveFormFields(activeFieldsWithValidations);
    }, [activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationType]);
    const getIntegrationSystemText = (item) => {
        var _a, _b, _c, _d;
        const platform = (_b = (_a = lookUpsOfIntegrationSystem.find(is => is.code === item.platform)) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
        let integrationType = DEFAULT_MANUAL_INTEGRATION_SYSTEM;
        if (item.integrationType !== integrationType) {
            integrationType = (_d = (_c = lookUpsOfIntegrationSystemType.find(is => is.code === item.integrationType)) === null || _c === void 0 ? void 0 : _c.text) !== null && _d !== void 0 ? _d : '';
        }
        return `${platform} - ${integrationType}`;
    };
    if (values.integrationCredentials.length > 0 || (activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationSystem)) {
        return (React.createElement("div", { className: "box-main-section" },
            React.createElement("section", { className: "box-section" },
                React.createElement("div", { className: "box-title" },
                    React.createElement("div", { className: "box-heading" }, localize(["Integration Systems"]))),
                React.createElement("div", { className: "box-description" }, values === null || values === void 0 ? void 0 : values.integrationCredentials.map((item) => (React.createElement(Tag, { key: item.platform, className: `${(item.integrationType === (activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationType) && item.platform === (activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationSystem)) ? 'active-tag' : ''} integration-tag`, onClick: (e) => {
                        e.preventDefault();
                        // Set the active integration system and type
                        setActiveIntegration({
                            integrationSystem: item.platform,
                            integrationType: item.integrationType,
                            dataFrequency: item.dataFrequency,
                            allowRawApiAccess: item.allowRawApiAccess,
                            allowKpiProcessingLayerAccess: item.allowKpiProcessingLayerAccess
                        });
                    } }, getIntegrationSystemText(item)))))),
            (activeIntegration === null || activeIntegration === void 0 ? void 0 : activeIntegration.integrationSystem) &&
                React.createElement(IntegrationFormFields, { isReadOnly: false, parentValues: values, onChange: setFieldValue, activeIntegration: activeIntegration, setActiveIntegration: setActiveIntegration, activeIntegrationSystemTypes: activeIntegrationSystemTypes, activeFormFields: activeFormFields })));
    }
    return null;
};
export default IntegrationCredentialsForm;
